// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CalendarModule as PrimeNgCalendarModule } from 'primeng/calendar';

// Afidium
import { CalendarComponent } from './calendar.component';

@NgModule({
    declarations: [
        CalendarComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        PrimeNgCalendarModule
    ],
    exports: [
        CalendarComponent,
    ],
})
export class CalendarModule {}
